// import React, { useContext, useState } from 'react';
// import { Card, CardBody } from 'reactstrap';
// import Heading from 'components/Heading';
// import ButtonV2 from 'components/common/ButtonV2';
// import { authContext } from 'contexts/AuthContext';
// import { useDispatch } from 'react-redux';
// import { toggleModal } from 'actions/orderDetailsAction';

// import Ordered from './components/Ordered';
// // import CustomTabs from 'components/CustomTabs';
// // import Dispatched from './components/Dispatched';
// // import { ORDERS_HEADING } from './constant';

// const Orders = () => {
//   // const [activeTab, setActiveTab] = useState('Ordered');

//   // const toggle = (tab) => {
//   //   if (activeTab !== tab) setActiveTab(tab);
//   // };

//   const { auth } = useContext(authContext);
//   const [showPendingOrders, setShowPendingOrders] = useState(false)

//   const dispatch = useDispatch()

//   // will uncomment later
//   // const fetchPendingOrderActions = async () => {
//   //   try {
//   //     const resp = await axiosGetAPI(`${process.env.REACT_APP_REST_API_ENDPOINT}/api/order/pending-action-orders`, auth)
//   //     console.log({resp })
//   //   } catch (error) {
//   //     console.log({ error})
//   //   } finally {
//   //     console.log("finally")
//   //   }
//   // }

//   // useEffect(() => {
//   //   fetchPendingOrderActions()
//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [])

//   return (
//     <>
//       <div className="mb-3 top-head pb-1 d-flex justify-content-between">
//         <Heading title="Orders" />
//           <ButtonV2
//             color="primary"
//             key="update-charges"
//             size="sm"
//             style={{
//               marginLeft: '10px',
//             }}
//             className="border-radius-4"
//             onClick={() => {
//               dispatch(toggleModal({showForm: true}))
//             }}
//             >
//               Pending Actions
//           </ButtonV2>
//       </div>

//       <Card className="border-0 card-box page-card-box">
//         <CardBody>
//           <Ordered show={showPendingOrders} setShow={setShowPendingOrders} />
//           {/* <CustomTabs
//             tabs={[ORDERS_HEADING.ORDERED, ORDERS_HEADING.DELIVERED]}
//             selectedTab={activeTab}
//             onTabChange={toggle}
//           />
//           <TabContent activeTab={activeTab}>
//             <TabPane tabId={ORDERS_HEADING.ORDERED}>
//               {activeTab === ORDERS_HEADING.ORDERED && <Ordered />}
//             </TabPane>
//             <TabPane tabId={ORDERS_HEADING.DELIVERED}>
//               {activeTab === ORDERS_HEADING.DELIVERED && <Dispatched />}
//             </TabPane>
//           </TabContent> */}
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default Orders;

import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import Heading from 'components/Heading';
import ButtonV2 from 'components/common/ButtonV2';
import { authContext } from 'contexts/AuthContext';
import { useDispatch, useSelector } from 'react-redux';
import { toggleModal, toggleAddOrderModal } from 'actions/orderDetailsAction';
import { axiosGetAPI } from 'services';

import Ordered from './components/Ordered';
import AddOrderDrawer from './Addorders/AddOrderDrawer';
import { prefetchAddOrderData } from './Addorders/orderService';

const PENDING_ACTIONS_SEEN_COUNT_KEY = 'orders_pending_actions_seen_count';

const Orders = () => {
  const { auth } = useContext(authContext);
  const [showPendingOrders, setShowPendingOrders] = useState(false);
  const [hasPendingActions, setHasPendingActions] = useState(false);
  const [pendingActionCount, setPendingActionCount] = useState(0);
  const dispatch = useDispatch();
  const { showAddOrderForm } = useSelector(
    (state) => state.orderDetailsReducer,
  );

  const readSeenPendingActionCount = useCallback(() => {
    try {
      const rawValue = window.localStorage.getItem(
        PENDING_ACTIONS_SEEN_COUNT_KEY,
      );
      if (rawValue === null) return null;
      const parsedValue = Number(rawValue);
      return Number.isFinite(parsedValue) ? parsedValue : null;
    } catch (error) {
      return null;
    }
  }, []);

  const writeSeenPendingActionCount = useCallback((count) => {
    try {
      window.localStorage.setItem(
        PENDING_ACTIONS_SEEN_COUNT_KEY,
        String(count),
      );
    } catch (error) {
      console.error('Failed to persist seen pending action count', error);
    }
  }, []);

  const fetchPendingActionCount = useCallback(
    async ({ initializeBaseline = false } = {}) => {
      try {
        const resp = await axiosGetAPI(
          `${process.env.REACT_APP_REST_API_ENDPOINT}order/pending-action-orders?pageSize=1&pageNum=0`,
          auth,
        );
        const totalPendingActions = resp?.data?.data?.totalElements || 0;
        setPendingActionCount(totalPendingActions);

        const seenCount = readSeenPendingActionCount();
        if (initializeBaseline && seenCount === null) {
          writeSeenPendingActionCount(totalPendingActions);
          setHasPendingActions(false);
          return;
        }

        const baselineCount = seenCount ?? 0;
        setHasPendingActions(totalPendingActions > baselineCount);
      } catch (error) {
        console.error('Failed to fetch pending actions count', error);
        setHasPendingActions(false);
      }
    },
    [auth, readSeenPendingActionCount, writeSeenPendingActionCount],
  );

  useEffect(() => {
    prefetchAddOrderData();
    fetchPendingActionCount({ initializeBaseline: true });
  }, [fetchPendingActionCount]);

  useEffect(() => {
    const handleOrderCreated = () => {
      fetchPendingActionCount();
    };

    window.addEventListener('orderCreated', handleOrderCreated);
    return () => {
      window.removeEventListener('orderCreated', handleOrderCreated);
    };
  }, [fetchPendingActionCount]);

  useEffect(() => {
    if (!showAddOrderForm) {
      fetchPendingActionCount();
    }
  }, [showAddOrderForm, fetchPendingActionCount]);

  const handlePendingActionsClick = () => {
    writeSeenPendingActionCount(pendingActionCount);
    setHasPendingActions(false);
    dispatch(toggleModal({ showForm: true }));
  };

  return (
    <>
      <div className="mb-3 top-head pb-1 d-flex justify-content-between">
        <Heading title="Orders" />
        <div className="d-flex gap-2">
          <ButtonV2
            color="primary"
            key="add-order"
            size="sm"
            className="border-radius-4"
            onClick={() => {
              dispatch(toggleAddOrderModal({ showAddOrderForm: true }));
            }}
          >
            Add Order
          </ButtonV2>
          <div style={{ position: 'relative', display: 'inline-flex' }}>
            <ButtonV2
              color="primary"
              key="update-charges"
              size="sm"
              className="border-radius-4"
              onClick={handlePendingActionsClick}
            >
              Pending Actions
            </ButtonV2>
            {hasPendingActions && (
              <span
                aria-label="Pending actions available"
                style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '-4px',
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  background: '#ff3b30',
                  border: '1px solid #ffffff',
                  zIndex: 1,
                }}
              />
            )}
          </div>
        </div>
      </div>

      <Card className="border-0 card-box page-card-box">
        <CardBody>
          <Ordered show={showPendingOrders} setShow={setShowPendingOrders} />
        </CardBody>
      </Card>

      {/* Add Order Drawer */}
      <AddOrderDrawer />
    </>
  );
};

export default Orders;
